import { Injectable } from '@angular/core';
import _refiner from 'refiner-js';
import { BaseDataService } from './base.data.service';
import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { RefinerResultDTO } from '../interfaces/refiner-result';
import { environment } from '../../environments/environment';

export type RefinerEventName = 'TravelSchedulerCompleted';

@Injectable({ providedIn: 'root' })
export class RefinerSurveyService extends BaseDataService {
  public url = '/api/refiner';

  private surveyAlreadyInit = false;

  constructor(public http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  private getRefinerConfig(): Promise<RefinerResultDTO> {
    return this.http
      .get<RefinerResultDTO>(`${this.url}/refiner-config`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  public setProject() {
    if (!this.surveyAlreadyInit) {
      this.getRefinerConfig().then((res) => {
        _refiner('setProject', res.projectId);
        _refiner('identifyUser', {
          id: res.userId,
          email: res.userEmail,
          name: res.userName,
        });
        this.surveyAlreadyInit = true;
      });
    }
  }

  public trackEvent(eventName: RefinerEventName) {
    _refiner('trackEvent', eventName);
  }
}
